import React from 'react'

const IntegerInput = (props : React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>,HTMLInputElement>) => {

  const preventDecimal = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === '.') {
      event.preventDefault();
    }
  }

  return <input {...props } type="number" onKeyPress={ preventDecimal }></input>
}

export default IntegerInput;
